// extracted by mini-css-extract-plugin
export default {"infoBox":"infoItem_infoBox__fU6C7","label":"infoItem_label__xut3I","info":"infoItem_info__5CohO","link":"infoItem_link__xO8o6","underline":"infoItem_underline__orQ79"};